// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Montserrat", sans-serif;
  -webkit-user-select: none;
          user-select: none;
  overscroll-behavior: none;
  -webkit-tap-highlight-color: transparent;
}

a {
  text-decoration: none;
  color: inherit;
}

input {
  border: none;
  outline: none;
}

.lightbox-icon
{
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
}

.calculation__select_new
{

    width: calc(((100% - 60px) / 3)* 2 + 30px);
}
.calculation__item_top .calculation__select_new
{
  width: 100%;
}

.calculation__select_full
{
  width: 100%;
}
.calculation__select_new .react-select__value-container .react-select__single-value .span
{
    max-width: fit-content;
    padding: 4px 16px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 700;
    font-style: normal;
    margin: 7px;
        float: left;
}

.calculation__select_new .react-select__value-container .react-select__single-value .span span 
{
    width: 100%;
    display: block;
    font-size: 8px;
}

.calculation__select_new img
{
    width: 36px;
    height: 36px;
    border-radius: 50%;
    object-fit: cover;
    float: right;
    margin: 8px 0 0;
}

.calculation__select_new .react-select__indicator-separator
{
  display: none;
}

.calculation__select_new .react-select__indicator
{
  color: #000;
}

.calculation__select_new .react-select__control
{
      min-height: 53px;
    border-radius: 8px;
    border: 1px solid #dde1eb;
}
.calculation__select_new .react-select__menu .color_option
{
  overflow: hidden;
}

.calculation__select_new .react-select__menu img
{
  width: 25px;
  height: 25px;
  float: right;
  margin: 0;
}

.calculation__select_new .react-select__menu .span
{
  padding: 0;
  float: left;
    line-height: 26px;
}
.calculation__select_new .react-select__menu .span span 
{
  font-size: 10px;
  clear: both;
    padding: 4px 16px;
    border-radius: 4px;
    background: #60656e;
    color: #fff;
    margin-left: 5px;
}

.ReactModal__Content--after-open
{
    max-width: 1160px;
    left: 50% !important;
    margin-left: -580px;
    inset: unset;
    top: 50%;
    padding: 50px!important;
    border-radius: 30px!important;
        overflow: hidden;
        max-height: 660px;
}

.ReactModal__Content--after-open .calculation__grades
{
  overflow-x: auto;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); 
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; 
  overflow: hidden; 
}

.modal-content {
  background: white;
  border-radius: 8px;
  max-width: 1160px;
  width: 80%; 
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  padding: 50px 50px 30px 50px; 
  overflow: hidden;
  position: relative;
}

.close-button {
position: absolute;
    top: 0px;
    right: 10px;
    background: transparent;
    border: none;
    font-size: 45px;
    cursor: pointer;
}

.modal-body {
  padding: 0; 
  overflow-y: auto; 
  max-height: 400px; 
}

.image-list {
  display: flex;
  flex-direction: column;
  overflow-y: auto; 
  max-height: 400px;
  background-color: #FAFAFA;
  padding: 10px;
  scrollbar-width: thin; 
  scrollbar-color: #DFDCDC transparent; 
}

.modal-body .calculation__grades .calculation__grade
{
  box-sizing: border-box;
  max-width: 232px;
  background: #FFFFFF;
  border: 1px solid #ECEEF4;
  border-radius: 16px;
  display: block;
}

.calculation__grades.washing.model .calculation__grade
{
    max-width: calc((100% - 60px) / 2);
    width: calc((100% - 60px) / 2);
}

.calculation__grades.washing.model .calculation__grade span,.calculation__grades.washing.model .calculation__grade p, .calculation__grades.washing.model .calculation__grade h3
{
  display: none;
}


.modal-body .calculation__grades .calculation__grade .block_image
{
    display: block;
    text-align: center;
}

.modal-body .calculation__grades .calculation__grade .full_image
{
  max-width:125px;
}
.modal-body .calculation__grades .calculation__grade p 
{
  margin-top: 5px;
  font-size: 12px;
}

.modal-body .calculation__grades.washing.model .calculation__grade .full_image
{
max-width: 100%;
}
.image-list::-webkit-scrollbar {
  width: 8px; 
}

.image-list::-webkit-scrollbar-thumb {
  background-color: #DFDCDC;
  border-radius: 8px; 
}

.image-item {
  margin: 24px 0; 
  text-align: center; 
}

.modal-image {
  max-width: 100%; 
  border-radius: 8px; 
}

.image-title {
  font-size: 18px;
  margin: 8px 0; 
}

.image-description {
  font-size: 12px;
}

.modal-footer {
  
  text-align: right; 
}

.save-button {
  background-color: #0C6B60; /* Цвет кнопки "Сохранить выбор" */
  color: white; 
  padding: 10px 20px; 
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;
}

.save-button:hover {
  background-color: #0B5B50; /* Более темный цвет при наведении */
}

.modal-body .notice
{
  box-sizing: border-box;

  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 16px 42px;
  gap: 24px;

  border: 1px solid #0C6B60;
  border-radius: 10px;

}

.modal-body table {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

@media (max-width: 1199px) {
    .modal-body {
        overflow-x: auto; /* Добавляем горизонтальную прокрутку */
    }

    .modal-body table {
        min-width: 1200px; /* Минимальная ширина таблицы */
    }
    .modal-body .notice
    {
      min-width: 400px;
    }
}

.modal-body table thead tr {
    width: 100%;
    display: flex;
    align-items: center;
    background: #fff;
    z-index: 99;
    border: 1px solid transparent !important;
}

.modal-body table tr {
  width: 100%;
    display: flex;
    align-items: center;
    background: #DDE1EB;
    border: 1px solid transparent;
    margin-bottom: 15px;
}
.modal-body table thead tr
{
  margin: 0;
}

.modal-body table tr {
      width: 100%;
    height: 65px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.modal-body table tr:nth-child(odd) {
  background: transparent;
    border: 1px solid #dde1eb;
}

.modal-body table tr td {
    height: 30px;
    border-right: 1px solid #b2bac6;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #b2bac6;
    font-size: 10px;
    font-weight: 500;
}

.modal-body table tbody tr td 
{

  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: #424242;
}
.modal-body table tr td
{
  width: 10%;
}
.modal-body table tr td:last-child {
    border-right: none;
}

.modal-body table tr td.title 
{
  justify-content: left;
  width: 60%;
}
.modal-body table tr td input
{

  background: #FFFFFF;
  border: 1px solid #DDE1EB;
  border-radius: 8px;
  text-align: center;
  padding: 10px;
  max-width: 100%;
  min-width: 45px;
}

.zoomed-image-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000; /* Обеспечить, что наложение будет выше других элементов */
}

.zoomed-image {
    max-width: 90%;
    max-height: 90%;
    background: #fff;
}


`, "",{"version":3,"sources":["webpack://./src/assets/global.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,qCAAqC;EACrC,yBAAiB;UAAjB,iBAAiB;EACjB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;AACnB;;AAEA;;;IAGI,0CAA0C;AAC9C;AACA;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;AACA;;IAEI,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;QACP,WAAW;AACnB;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,eAAe;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,WAAW;AACb;;AAEA;;MAEM,gBAAgB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,SAAS;AACX;;AAEA;;EAEE,UAAU;EACV,WAAW;IACT,iBAAiB;AACrB;AACA;;EAEE,eAAe;EACf,WAAW;IACT,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;;IAEI,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,QAAQ;IACR,uBAAuB;IACvB,6BAA6B;QACzB,gBAAgB;QAChB,iBAAiB;AACzB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,wCAAwC;EACxC,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;AACA,kBAAkB;IACd,QAAQ;IACR,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;IAEI,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;;EAEE,aAAa;AACf;;;AAGA;;IAEI,cAAc;IACd,kBAAkB;AACtB;;AAEA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,eAAe;AACjB;;AAEA;;AAEA,eAAe;AACf;AACA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB,EAAE,kCAAkC;EAC7D,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,oCAAoC;AACjE;;AAEA;;EAEE,sBAAsB;;EAEtB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;;EAET,yBAAyB;EACzB,mBAAmB;;AAErB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI;QACI,gBAAgB,EAAE,uCAAuC;IAC7D;;IAEA;QACI,iBAAiB,EAAE,+BAA+B;IACtD;IACA;;MAEE,gBAAgB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,wCAAwC;AAC5C;;AAEA;EACE,WAAW;IACT,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;AACvB;AACA;;EAEE,SAAS;AACX;;AAEA;MACM,WAAW;IACb,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;EACE,uBAAuB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;;;EAGE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;;EAEE,UAAU;AACZ;AACA;IACI,kBAAkB;AACtB;;AAEA;;EAEE,qBAAqB;EACrB,UAAU;AACZ;AACA;;;EAGE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa,EAAE,0DAA0D;AAC7E;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap\");\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Montserrat\", sans-serif;\n  user-select: none;\n  overscroll-behavior: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\ninput {\n  border: none;\n  outline: none;\n}\n\n.lightbox-icon\n{\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    cursor: pointer;\n}\n\n.calculation__select_new\n{\n\n    width: calc(((100% - 60px) / 3)* 2 + 30px);\n}\n.calculation__item_top .calculation__select_new\n{\n  width: 100%;\n}\n\n.calculation__select_full\n{\n  width: 100%;\n}\n.calculation__select_new .react-select__value-container .react-select__single-value .span\n{\n    max-width: fit-content;\n    padding: 4px 16px;\n    border-radius: 4px;\n    font-size: 16px;\n    font-weight: 700;\n    font-style: normal;\n    margin: 7px;\n        float: left;\n}\n\n.calculation__select_new .react-select__value-container .react-select__single-value .span span \n{\n    width: 100%;\n    display: block;\n    font-size: 8px;\n}\n\n.calculation__select_new img\n{\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    object-fit: cover;\n    float: right;\n    margin: 8px 0 0;\n}\n\n.calculation__select_new .react-select__indicator-separator\n{\n  display: none;\n}\n\n.calculation__select_new .react-select__indicator\n{\n  color: #000;\n}\n\n.calculation__select_new .react-select__control\n{\n      min-height: 53px;\n    border-radius: 8px;\n    border: 1px solid #dde1eb;\n}\n.calculation__select_new .react-select__menu .color_option\n{\n  overflow: hidden;\n}\n\n.calculation__select_new .react-select__menu img\n{\n  width: 25px;\n  height: 25px;\n  float: right;\n  margin: 0;\n}\n\n.calculation__select_new .react-select__menu .span\n{\n  padding: 0;\n  float: left;\n    line-height: 26px;\n}\n.calculation__select_new .react-select__menu .span span \n{\n  font-size: 10px;\n  clear: both;\n    padding: 4px 16px;\n    border-radius: 4px;\n    background: #60656e;\n    color: #fff;\n    margin-left: 5px;\n}\n\n.ReactModal__Content--after-open\n{\n    max-width: 1160px;\n    left: 50% !important;\n    margin-left: -580px;\n    inset: unset;\n    top: 50%;\n    padding: 50px!important;\n    border-radius: 30px!important;\n        overflow: hidden;\n        max-height: 660px;\n}\n\n.ReactModal__Content--after-open .calculation__grades\n{\n  overflow-x: auto;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5); \n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000; \n  overflow: hidden; \n}\n\n.modal-content {\n  background: white;\n  border-radius: 8px;\n  max-width: 1160px;\n  width: 80%; \n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  padding: 50px 50px 30px 50px; \n  overflow: hidden;\n  position: relative;\n}\n\n.close-button {\nposition: absolute;\n    top: 0px;\n    right: 10px;\n    background: transparent;\n    border: none;\n    font-size: 45px;\n    cursor: pointer;\n}\n\n.modal-body {\n  padding: 0; \n  overflow-y: auto; \n  max-height: 400px; \n}\n\n.image-list {\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto; \n  max-height: 400px;\n  background-color: #FAFAFA;\n  padding: 10px;\n  scrollbar-width: thin; \n  scrollbar-color: #DFDCDC transparent; \n}\n\n.modal-body .calculation__grades .calculation__grade\n{\n  box-sizing: border-box;\n  max-width: 232px;\n  background: #FFFFFF;\n  border: 1px solid #ECEEF4;\n  border-radius: 16px;\n  display: block;\n}\n\n.calculation__grades.washing.model .calculation__grade\n{\n    max-width: calc((100% - 60px) / 2);\n    width: calc((100% - 60px) / 2);\n}\n\n.calculation__grades.washing.model .calculation__grade span,.calculation__grades.washing.model .calculation__grade p, .calculation__grades.washing.model .calculation__grade h3\n{\n  display: none;\n}\n\n\n.modal-body .calculation__grades .calculation__grade .block_image\n{\n    display: block;\n    text-align: center;\n}\n\n.modal-body .calculation__grades .calculation__grade .full_image\n{\n  max-width:125px;\n}\n.modal-body .calculation__grades .calculation__grade p \n{\n  margin-top: 5px;\n  font-size: 12px;\n}\n\n.modal-body .calculation__grades.washing.model .calculation__grade .full_image\n{\nmax-width: 100%;\n}\n.image-list::-webkit-scrollbar {\n  width: 8px; \n}\n\n.image-list::-webkit-scrollbar-thumb {\n  background-color: #DFDCDC;\n  border-radius: 8px; \n}\n\n.image-item {\n  margin: 24px 0; \n  text-align: center; \n}\n\n.modal-image {\n  max-width: 100%; \n  border-radius: 8px; \n}\n\n.image-title {\n  font-size: 18px;\n  margin: 8px 0; \n}\n\n.image-description {\n  font-size: 12px;\n}\n\n.modal-footer {\n  \n  text-align: right; \n}\n\n.save-button {\n  background-color: #0C6B60; /* Цвет кнопки \"Сохранить выбор\" */\n  color: white; \n  padding: 10px 20px; \n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 20px;\n}\n\n.save-button:hover {\n  background-color: #0B5B50; /* Более темный цвет при наведении */\n}\n\n.modal-body .notice\n{\n  box-sizing: border-box;\n\n  /* Auto layout */\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 16px 42px;\n  gap: 24px;\n\n  border: 1px solid #0C6B60;\n  border-radius: 10px;\n\n}\n\n.modal-body table {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n@media (max-width: 1199px) {\n    .modal-body {\n        overflow-x: auto; /* Добавляем горизонтальную прокрутку */\n    }\n\n    .modal-body table {\n        min-width: 1200px; /* Минимальная ширина таблицы */\n    }\n    .modal-body .notice\n    {\n      min-width: 400px;\n    }\n}\n\n.modal-body table thead tr {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    background: #fff;\n    z-index: 99;\n    border: 1px solid transparent !important;\n}\n\n.modal-body table tr {\n  width: 100%;\n    display: flex;\n    align-items: center;\n    background: #DDE1EB;\n    border: 1px solid transparent;\n    margin-bottom: 15px;\n}\n.modal-body table thead tr\n{\n  margin: 0;\n}\n\n.modal-body table tr {\n      width: 100%;\n    height: 65px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.modal-body table tr:nth-child(odd) {\n  background: transparent;\n    border: 1px solid #dde1eb;\n}\n\n.modal-body table tr td {\n    height: 30px;\n    border-right: 1px solid #b2bac6;\n    padding: 0 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #b2bac6;\n    font-size: 10px;\n    font-weight: 500;\n}\n\n.modal-body table tbody tr td \n{\n\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 17px;\n  color: #424242;\n}\n.modal-body table tr td\n{\n  width: 10%;\n}\n.modal-body table tr td:last-child {\n    border-right: none;\n}\n\n.modal-body table tr td.title \n{\n  justify-content: left;\n  width: 60%;\n}\n.modal-body table tr td input\n{\n\n  background: #FFFFFF;\n  border: 1px solid #DDE1EB;\n  border-radius: 8px;\n  text-align: center;\n  padding: 10px;\n  max-width: 100%;\n  min-width: 45px;\n}\n\n.zoomed-image-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.8);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000; /* Обеспечить, что наложение будет выше других элементов */\n}\n\n.zoomed-image {\n    max-width: 90%;\n    max-height: 90%;\n    background: #fff;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
